import React from "react";
import { getBaseColumns, renderActionColumn, calculateActionsColumnWidth } from "../../utils/sharedTableColumns";
import { getUserDetails } from "../../utils/helper";
import { FieldLabels } from "../../constants/fieldLabels";

export const orderColumns = ({
  openReportEditor, // Opens report editor in new tab (for both patient name and action icon)
  viewNotes,
  // Additional handlers for full functionality (same as PACS)
  openViewer,
  showOrdDetails,
  openRadDesk,
  printReport,
  downloadDocxReport,
  viewReport,
  editSignedOffReport,
  handleShareStudy,
  handleDownloadStudy,
  handleSelectSeries,
  addFile
}) => {
  const userDetails = getUserDetails();
  const baseColumns = getBaseColumns();

  // Customize patient name column to open report editor in new tab
  const patientNameColumn = baseColumns.find(col => col.key === 'pat_name');
  if (patientNameColumn) {
    const originalRender = patientNameColumn.render;
    patientNameColumn.render = (text, record) => originalRender(text, record, openReportEditor);
  }

  // Action column configuration - now includes all PACS actions
  const actionConfig = {
    openViewer,
    showOrdDetails,
    openRadDesk,
    openReportEditor, // Same function - opens in new tab
    addFile,
    viewNotes,
    printReport,
    downloadDocxReport,
    viewReport,
    editSignedOffReport,
    handleShareStudy,
    handleDownloadStudy,
    handleSelectSeries,
    role: userDetails?.user_type,
    pageType: 'pacs' // Use 'pacs' to show all actions
  };

  const actionsColumn = {
    title: FieldLabels.ACTIONS,
    key: "actions_column",
    fixed: 'right',
    render: renderActionColumn(actionConfig),
    width: calculateActionsColumnWidth(actionConfig), // Dynamic width based on visible icons
  };

  return [
    ...baseColumns,
    actionsColumn
  ].filter(itm => !itm.hidden);
};
